import type { GameStateManager } from '../../game/GameState';
import type { GameData } from '../../game/types';
import type { ResearchModal } from '../ResearchModal';
import type { SilverBulletModal } from '../SilverBulletModal';
import type { RecruitModal } from '../RecruitModal';
import type { MenuModal } from '../MenuModal';
import type { HowToPlayModal } from '../HowToPlayModal';
import type { ControlsModal } from '../ControlsModal';
import type { CompendiumModal } from '../CompendiumModal';

export class ModalCoordinator {
  constructor(
    private researchModal: ResearchModal,
    private silverBulletModal: SilverBulletModal,
    private recruitModal: RecruitModal,
    private menuModal: MenuModal,
    private howToPlayModal: HowToPlayModal,
    private controlsModal: ControlsModal,
    private compendiumModal: CompendiumModal
  ) {}

  isAnyModalOpen(): boolean {
    return this.researchModal.isOpen() ||
           this.silverBulletModal.isOpen() ||
           this.recruitModal.isOpen() ||
           this.menuModal.isOpen();
  }

  isModalOpen(modalType: 'research' | 'silverBullet' | 'recruit' | 'menu'): boolean {
    switch (modalType) {
      case 'research':
        return this.researchModal.isOpen();
      case 'silverBullet':
        return this.silverBulletModal.isOpen();
      case 'recruit':
        return this.recruitModal.isOpen();
      case 'menu':
        return this.menuModal.isOpen();
      default:
        return false;
    }
  }

  closeAllModals(): void {
    if (this.researchModal.isOpen()) this.researchModal.hide();
    if (this.silverBulletModal.isOpen()) this.silverBulletModal.hide();
    if (this.recruitModal.isOpen()) this.recruitModal.hide();
    if (this.menuModal.isOpen()) this.menuModal.hide();
    if (this.howToPlayModal.isOpen()) this.howToPlayModal.hide();
    if (this.controlsModal.isOpen()) this.controlsModal.hide();
    if (this.compendiumModal.isOpen()) this.compendiumModal.hide();
  }
}

